<template>
<v-container fluid>
    <v-card class="ma-2" flat>
        <v-progress-linear indeterminate color="yellow darken-2" v-if="programLoading"></v-progress-linear>
    </v-card>
    <program-member-data-component :uid="uid"></program-member-data-component>
    <v-layout mt-4>
        <v-flex >
            <v-btn variant="flat" @click="showTab('bmi')" text color="primary" v-if="tab=='bmi'">
                <h3>ตัวชี้วัดหลัก</h3>
            </v-btn>
            <v-btn variant="flat" @click="showTab('bmi')" text v-else>
                ตัวชี้วัดหลัก
            </v-btn>
            <v-btn variant="flat" @click="showTab('bodyFat')" text color="primary" v-if="tab=='bodyFat'">
                <h3>องค์ประกอบร่างกาย</h3>
            </v-btn>
            <v-btn variant="flat" @click="showTab('bodyFat')" text v-else>
                องค์ประกอบร่างกาย
            </v-btn>
            <v-btn variant="flat" @click="showTab('pressure')" text color="primary" v-if="tab=='pressure'">
                <h3>ผลเลือด</h3>
            </v-btn>
            <v-btn variant="flat" @click="showTab('pressure')" text v-else>
                ผลเลือด
            </v-btn>
        </v-flex>
    </v-layout>
    <v-layout wrap="true" v-if="tab == 'bmi' && ((!this.modLoading['weightData'] && !this.modLoading['waistData'] && !this.modLoading['workoutData'] && !this.modLoading['foodData'] && !this.modLoading['sleepData']) || this.fromLoadChart)">
        <v-flex xs12 md6>
            <chart-member-component-vue ref="weightData" :chartInfo="chartWeightMember" :loading="this.modLoading['weightData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
        <v-flex xs12 md6>
            <chart-member-component-vue ref="waistData" :chartInfo="chartWaistMember" :loading="this.modLoading['waistData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
        <v-flex xs12 md12>
            <chart-member-component-vue ref="workoutData" :chartInfo="chartWorkoutMember" :loading="this.modLoading['workoutData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
        <v-flex xs12 md6>
            <chart-member-component-vue ref="foodData" :chartInfo="chartFoodMember" :loading="this.modLoading['foodData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
        <v-flex xs12 md6>
            <chart-member-component-vue ref="sleepData" :chartInfo="chartSleepMember" :loading="this.modLoading['sleepData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
    </v-layout>
    <v-layout wrap="true" v-else-if="tab == 'bodyFat' && ((!this.modLoading['bmiData'] && !this.modLoading['bodyFatData'] && !this.modLoading['muscleData']) || this.fromLoadChart)">
        <v-flex xs12 md6>
            <chart-member-component-vue ref="bodyFatData" :chartInfo="chartBodyFatMember" :loading="this.modLoading['bodyFatData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
        <v-flex xs12 md6>
            <chart-member-component-vue ref="muscleData" :chartInfo="chartMuscleMember" :loading="this.modLoading['muscleData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
        <v-flex xs12 md6>
            <chart-member-component-vue ref="bmiData" :chartInfo="chartBMIMember" :loading="this.modLoading['bmiData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
    </v-layout>
    <v-layout wrap="true" v-else-if="tab == 'pressure' && !this.modLoading['pressureUpperData'] && !this.modLoading['pressureLowerData'] && !this.modLoading['glucoseData'] && !this.modLoading['hba1cData'] && !this.modLoading['cholesterolData'] && !this.modLoading['hdlData'] && !this.modLoading['ldlData'] && !this.modLoading['triglyceridesData']">
        <v-flex xs12 md3>
            <chart-member-component-vue ref="pressureUpperData" :chartInfo="chartPressureUpperMember" :loading="this.modLoading['pressureUpperData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
        <v-flex xs12 md3>
            <chart-member-component-vue ref="pressureLowerData" :chartInfo="chartPressureLowerMember" :loading="this.modLoading['pressureLowerData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
        <v-flex xs12 md3>
            <chart-member-component-vue ref="glucoseData" :chartInfo="chartGlucoseMember" :loading="this.modLoading['glucoseData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
        <v-flex xs12 md3>
            <chart-member-component-vue ref="hba1cData" :chartInfo="chartHba1cMember" :loading="this.modLoading['hba1cData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
        <v-flex xs12 md3>
            <chart-member-component-vue ref="cholesterolData" :chartInfo="chartCholesterolMember" :loading="this.modLoading['cholesterolData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
        <v-flex xs12 md3>
            <chart-member-component-vue ref="hdlData" :chartInfo="chartHdlMember" :loading="this.modLoading['hdlData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
        <v-flex xs12 md3>
            <chart-member-component-vue ref="ldlData" :chartInfo="chartLdlMember" :loading="this.modLoading['ldlData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
        <v-flex xs12 md3>
            <chart-member-component-vue ref="triglyceridesData" :chartInfo="chartTriglyceridesMember" :loading="this.modLoading['triglyceridesData']" chartClass="" @toUpdateChart="toUpdateChart($event)" />
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import formatData from "../utils/formatData";
import getUserInfoByUserId from "../data/getUserInfoByUserId";
import getProgramInfoById from "../data/getProgramInfoById";
import ChartMemberComponentVue from "../components/ChartMemberComponent.vue";
import colors from 'vuetify/lib/util/colors';
import moment from "moment";
import bqGetProgramMemberSummary from "../data/bqGetProgramMemberSummary";
import ProgramMemberDataComponent from "../components/ProgramMemberDataComponent.vue";
export default {
    name: 'ProgramViewMemberReport',
    metaInfo: {
        title: 'Program View Member Report'
    },
    components: {
        ChartMemberComponentVue,
        ProgramMemberDataComponent
    },
    data() {
        return {
            title: '',
            subTitle: '',
            programLoading: true,
            loading: false,
            fromLoadChart: false,
            modLoading: {
                bmiData: false,
                waistData: false,
                workoutData: false,
                foodData: false,
                sleepData: false,
                bodyFatData: false,
                muscleData: false,
                weightData: false,
                pressureUpperData: false,
                pressureLowerData: false,
                glucoseData: false,
                hba1cData: false,
                cholesterolData: false,
                hdlData: false,
                ldlData: false,
                triglyceridesData: false
            },
            enableEndProgram: false,
            programInfo: {},
            tab: null,
            filterStartDate: '',
            filterEndDate: '',
            filterOptionSelected: [],
            wellnessData: [],
            userInfo: {
                name: ''
            },
            chartWaistMember: {
                noData: true,
                chartTitle: "Waist",
                toolbarShow: false,
                titleHide: true,
                title: 'Waist',
                // chartType: 'line',
                color: 'blue',
                series: [{
                    name: "Waist",
                    color: '#368FFB',
                    data: []
                }],
                forceNiceScale: true,
                maxY: 80,
                isShowDateFilter: true,
                mod: 'waistData'
            },
            chartBMIMember: {
                noData: true,
                chartTitle: "BMI",
                title: 'BMI',
                // chartType: 'line',
                toolbarShow: false,
                titleHide: true,
                color: '#FBB018',
                series: [{
                    name: "BMI",
                    color: '#FBB018',
                    data: []
                }],
                maxY: 35,
                tickAmount: 2,
                forceNiceScale: true,
                isShowDateFilter: true,
                mod: 'bmiData'
            },
            chartWorkoutMember: {
                noData: true,
                chartTitle: "เวลาออกกำลังกาย",
                title: 'เวลาออกกำลังกาย',
                chartType: 'bar',
                // xaxisType: 'category',
                toolbarShow: false,
                titleHide: true,
                color: 'pink',
                series: [{
                    name: "Workout",
                    color: '#E91E63',
                    data: []
                }],
                maxY: 300,
                tickAmount: 2,
                forceNiceScale: true,
                isShowDateFilter: true,
                mod: 'workoutData'
            },
            chartFoodMember: {
                noData: true,
                chartTitle: "ปริมาณผักผลไม้",
                title: 'ปริมาณผักผลไม้',
                toolbarShow: false,
                titleHide: true,
                chartType: 'bar',
                color: 'green',
                series: [{
                    name: "Food",
                    color: '#26E396',
                    data: []
                }],
                forceNiceScale: true,
                maxY: 10,
                isShowDateFilter: true,
                decimal: true,
                mod: 'foodData'
            },
            chartSleepMember: {
                noData: true,
                chartTitle: "การนอน",
                title: 'การนอน',
                toolbarShow: false,
                titleHide: true,
                chartType: 'bar',
                color: 'purple',
                series: [{
                    name: "Sleep",
                    color: colors.purple.darken1,
                    data: []
                }],
                forceNiceScale: true,
                maxY: 10,
                isShowDateFilter: true,
                decimal: true,
                mod: 'sleepData'
            },
            chartBodyFatMember: {
                noData: true,
                chartTitle: "Body Fat %",
                toolbarShow: false,
                titleHide: true,
                title: 'Body Fat %',
                // chartType: 'line',
                color: '368FFB',
                series: [{
                    name: "Body Fat %",
                    color: '#368FFB',
                    data: []
                }],
                forceNiceScale: true,
                maxY: 30,
                isShowDateFilter: true,
                mod: 'bodyFatData'
            },
            chartMuscleMember: {
                noData: true,
                chartTitle: "Muscle Mass (kg)",
                toolbarShow: false,
                titleHide: true,
                title: 'Muscle Mass (kg)',
                // chartType: 'line',
                color: '#26E396',
                series: [{
                    name: "Muscle Mass (kg)",
                    color: '#26E396',
                    data: []
                }],
                forceNiceScale: true,
                maxY: 30,
                isShowDateFilter: true,
                mod: 'muscleData'
            },
            chartWeightMember: {
                noData: true,
                chartTitle: "Weight (kg)",
                toolbarShow: false,
                titleHide: true,
                title: 'Weight (kg)',
                // chartType: 'line',
                color: 'green',
                series: [{
                    name: "Weight (kg)",
                    color: '#26E396',
                    data: []
                }],
                forceNiceScale: true,
                maxY: 30,
                isShowDateFilter: true,
                mod: 'weightData'
            },
            chartPressureUpperMember: {
                noData: true,
                chartTitle: "pressureUpper",
                title: 'pressureUpper',
                toolbarShow: false,
                titleHide: true,
                xaxisType: 'category',
                chartType: 'bar',
                color: 'pink',
                series: [{
                    name: "Pressure Upper",
                    color: colors.pink.darken1,
                    data: []
                }],
                forceNiceScale: true,
                maxY: 10,
                isShowDateFilter: false,
                decimal: true,
                mod: 'pressureUpperData'
            },
            chartPressureLowerMember: {
                noData: true,
                chartTitle: "pressureLower",
                title: 'pressureLower',
                toolbarShow: false,
                titleHide: true,
                xaxisType: 'category',
                chartType: 'bar',
                color: 'purple',
                series: [{
                    name: "Pressure Lower",
                    color: colors.purple.darken1,
                    data: []
                }],
                forceNiceScale: true,
                maxY: 10,
                isShowDateFilter: false,
                decimal: true,
                mod: 'pressureLowerData'
            },
            chartGlucoseMember: {
                noData: true,
                chartTitle: "Glucose",
                title: 'Glucose',
                toolbarShow: false,
                titleHide: true,
                xaxisType: 'category',
                chartType: 'bar',
                color: 'blue',
                series: [{
                    name: "Glucose",
                    color: colors.blue.darken1,
                    data: []
                }],
                forceNiceScale: true,
                maxY: 10,
                isShowDateFilter: false,
                decimal: true,
                mod: 'glucoseData'
            },
            chartHba1cMember: {
                noData: true,
                chartTitle: "HbA1C",
                title: 'HbA1C',
                toolbarShow: false,
                titleHide: true,
                chartType: 'bar',
                xaxisType: 'category',
                color: 'cyan',
                series: [{
                    name: "HbA1C",
                    color: colors.cyan.darken1,
                    data: []
                }],
                forceNiceScale: true,
                maxY: 10,
                isShowDateFilter: false,
                decimal: true,
                mod: 'hba1cData'
            },
            chartCholesterolMember: {
                noData: true,
                chartTitle: "Cholesterol",
                title: 'Cholesterol',
                toolbarShow: false,
                titleHide: true,
                chartType: 'bar',
                xaxisType: 'category',
                color: 'green',
                series: [{
                    name: "Cholesterol",
                    color: '#26E396',
                    data: []
                }],
                forceNiceScale: true,
                maxY: 200,
                isShowDateFilter: false,
                decimal: true,
                mod: 'cholesterolData'
            },
            chartHdlMember: {
                noData: true,
                chartTitle: "HDL",
                title: 'HDL',
                toolbarShow: false,
                titleHide: true,
                xaxisType: 'category',
                chartType: 'bar',
                color: 'orange',
                series: [{
                    name: "HDL",
                    color: colors.orange.darken1,
                    data: []
                }],
                forceNiceScale: true,
                maxY: 100,
                isShowDateFilter: false,
                decimal: true,
                mod: 'hdlData'
            },
            chartLdlMember: {
                noData: true,
                chartTitle: "LDL",
                title: 'LDL',
                toolbarShow: false,
                titleHide: true,
                xaxisType: 'category',
                chartType: 'bar',
                color: 'teal',
                series: [{
                    name: "LDL",
                    color: colors.teal.darken1,
                    data: []
                }],
                forceNiceScale: true,
                maxY: 100,
                isShowDateFilter: false,
                decimal: true,
                mod: 'ldlData'
            },
            chartTriglyceridesMember: {
                noData: true,
                chartTitle: "Triglycerides",
                title: 'Triglycerides',
                toolbarShow: false,
                titleHide: true,
                xaxisType: 'category',
                chartType: 'bar',
                color: 'indigo',
                series: [{
                    name: "Triglycerides",
                    color: colors.indigo.darken1,
                    data: []
                }],
                forceNiceScale: true,
                maxY: 100,
                isShowDateFilter: false,
                decimal: true,
                mod: 'triglyceridesData'
            }
        };
    },
    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Coach Program";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
        this.id = this.$route.params.id;
        this.uid = this.$route.params.uid;
        this.tab = this.$route.params.tab;
    },
    computed: {
        ...mapGetters([
            "isAuthenticated",
            "loggedInUserId",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessCoachAdmin",
            "isAccessOrgAdmin"
        ]),
    },
    methods: {
        initialize() {
            if (this.isAccessCoachAdmin || this.isAccessOrgAdmin || 1==1) {
                (async () => {
                    this.loading = true;
                    this.programLoading = true;
                    this.programInfo = await getProgramInfoById(this.id, this.uid, 1);

                    this.userInfo = await getUserInfoByUserId(this.uid);
                    this.programLoading = false;
                    this.title = this.userInfo.name + ' (' + this.programInfo.name + ')';

                    this.startDate = this.programInfo.startDate;
                    this.endDate = this.programInfo.endDate;
                    this.loadChart();
                    this.loading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        showTab(tab) {
            if (tab != this.tab) {
                this.tab = tab;
                this.$router.push(`/program/${this.$route.params.mod}/view/${this.id}/${this.uid}/report/${tab}`);
                this.loadChart();
            }
        },
        showLink(tab) {
            if (tab != this.tab) {
                return `/program/${this.$route.params.mod}/view/${this.id}/${this.uid}/report/${tab}`;
            }
        },
        loadChart() {
            let modList = ['bmiData', 'weightData', 'waistData', 'workoutData', 'foodData', 'sleepData', 'bodyFatData', 'muscleData', 'pressureUpperData', 'pressureLowerData', 'glucoseData', 'hba1cData', 'cholesterolData', 'hdlData', 'ldlData', 'triglyceridesData'];
            if (this.tab == 'bmi') {
                this.subTitle = 'ตัวชี้วัดหลัก';
                modList = ['weightData', 'waistData', 'workoutData', 'foodData', 'sleepData'];
            } else if (this.tab == 'bodyFat') {
                this.subTitle = 'องค์ประกอบร่างกาย';
                modList = ['bodyFatData', 'muscleData', 'bmiData'];
            } else if (this.tab == 'pressure') {
                this.subTitle = 'ผลเลือด';
                modList = ['pressureUpperData', 'pressureLowerData', 'glucoseData', 'hba1cData', 'cholesterolData', 'hdlData', 'ldlData', 'triglyceridesData'];
            }
            Promise.all(
                modList.map(async (item) => {
                    //setup filter option
                    await this.getFilterOptionSelected(item);
                    await this.toUpdateChart({
                        mod: item,
                        filterOptionSelected: this.filterOptionSelected[item] || '-'
                    });
                })
            );
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        calculateMaxY(maxValue, maxY, point) {
            //compare with maxY
            if (maxValue > maxY) {
                maxY = (maxValue) * 1 + point;
            }
            return maxY;
        },
        calculatePercentChanges(a, b) {
            //get max value
            // return (b-a)/a*100;
            let pc = formatData('number', (b - a) / a * 100);
            if (pc > 0) {
                pc = `+${pc}`;
            }
            return pc;
        },
        verifyEditState() {
            this.$refs.programMemberFormComponent.verifyEditState();
        },
        //setup filter option
        getFilterOptionSelected(mod) {
            if (mod == 'bmiData') {
                //prepare filter option
                if (this.chartBMIMember.filterOptionSelected == undefined) {
                    this.chartBMIMember.filterOptionSelected = 'program';
                }
                this.filterOptionSelected[mod] = this.chartBMIMember.filterOptionSelected;
                this.chartBMIMember.filterOptionList = [{
                        value: 'program',
                        text: 'ข่วงที่ร่วมโปรแกรม'
                    },
                    {
                        value: 'all',
                        text: 'ทั้งหมด'
                    }
                ];
            } else if (mod == 'waistData') {
                //prepare filter option
                if (this.chartWaistMember.filterOptionSelected == undefined) {
                    this.chartWaistMember.filterOptionSelected = 'program';
                }
                this.filterOptionSelected[mod] = this.chartWaistMember.filterOptionSelected;
                this.chartWaistMember.filterOptionList = [{
                        value: 'program',
                        text: 'ข่วงที่ร่วมโปรแกรม'
                    },
                    {
                        value: 'all',
                        text: 'ทั้งหมด'
                    }
                ];
            } else if (mod == 'workoutData') {
                //prepare filter option
                if (this.chartWorkoutMember.filterOptionSelected == undefined) {
                    this.chartWorkoutMember.filterOptionSelected = moment().subtract(6, 'M').format('YYYY-MM-DD') + ':' + moment().format('YYYY-MM-DD');
                }
                this.filterOptionSelected[mod] = this.chartWorkoutMember.filterOptionSelected;
                this.chartWorkoutMember.filterOptionList = [{
                        value: moment().subtract(6, 'M').format('YYYY-MM-DD') + ':' + moment().format('YYYY-MM-DD'),
                        text: moment().subtract(6, 'M').format('DD MMM YY') + ' to ' + moment().format('DD MMM YY')
                    },
                    {
                        value: moment().subtract(12, 'M').format('YYYY-MM-DD') + ':' + moment().subtract(6, 'M').format('YYYY-MM-DD'),
                        text: moment().subtract(12, 'M').format('DD MMM YY') + ' to ' + moment().subtract(6, 'M').format('DD MMM YY')
                    }
                ];
            } else if (mod == 'foodData') {
                //prepare filter option
                if (this.chartFoodMember.filterOptionSelected == undefined) {
                    this.chartFoodMember.filterOptionSelected = moment().startOf('month').format('YYYY-MM-DD') + ':' + moment().endOf('month').format('YYYY-MM-DD');
                }
                this.filterOptionSelected[mod] = this.chartFoodMember.filterOptionSelected;
                this.chartFoodMember.filterOptionList = [];
                for (let i = 0; i < 12; i++) {
                    this.chartFoodMember.filterOptionList.push({
                        value: moment().subtract(i, 'M').startOf('month').format('YYYY-MM-DD') + ':' + moment().subtract(i, 'M').endOf('month').format('YYYY-MM-DD'),
                        text: moment().subtract(i, 'M').startOf('month').format('MMM YY')
                    });
                }
            } else if (mod == 'sleepData') {
                //prepare filter option
                if (this.chartSleepMember.filterOptionSelected == undefined) {
                    this.chartSleepMember.filterOptionSelected = moment().startOf('month').format('YYYY-MM-DD') + ':' + moment().endOf('month').format('YYYY-MM-DD');
                }
                this.filterOptionSelected[mod] = this.chartSleepMember.filterOptionSelected;
                this.chartSleepMember.filterOptionList = [];
                for (let i = 0; i < 12; i++) {
                    this.chartSleepMember.filterOptionList.push({
                        value: moment().subtract(i, 'M').startOf('month').format('YYYY-MM-DD') + ':' + moment().subtract(i, 'M').endOf('month').format('YYYY-MM-DD'),
                        text: moment().subtract(i, 'M').startOf('month').format('MMM YY')
                    });
                }
            } else if (mod == 'bodyFatData') {
                //prepare filter option
                if (this.chartBodyFatMember.filterOptionSelected == undefined) {
                    this.chartBodyFatMember.filterOptionSelected = 'program';
                }
                this.filterOptionSelected[mod] = this.chartBodyFatMember.filterOptionSelected;
                this.chartBodyFatMember.filterOptionList = [{
                        value: 'program',
                        text: 'ข่วงที่ร่วมโปรแกรม'
                    },
                    {
                        value: 'all',
                        text: 'ทั้งหมด'
                    }
                ];
            } else if (mod == 'muscleData') {
                //prepare filter option
                if (this.chartMuscleMember.filterOptionSelected == undefined) {
                    this.chartMuscleMember.filterOptionSelected = 'program';
                }
                this.filterOptionSelected[mod] = this.chartMuscleMember.filterOptionSelected;
                this.chartMuscleMember.filterOptionList = [{
                        value: 'program',
                        text: 'ข่วงที่ร่วมโปรแกรม'
                    },
                    {
                        value: 'all',
                        text: 'ทั้งหมด'
                    }
                ];
            } else if (mod == 'weightData') {
                //prepare filter option
                if (this.chartWeightMember.filterOptionSelected == undefined) {
                    this.chartWeightMember.filterOptionSelected = 'program';
                }
                this.filterOptionSelected[mod] = this.chartWeightMember.filterOptionSelected;
                this.chartWeightMember.filterOptionList = [{
                        value: 'program',
                        text: 'ข่วงที่ร่วมโปรแกรม'
                    },
                    {
                        value: 'all',
                        text: 'ทั้งหมด'
                    }
                ];
            }
        },
        //set after click filter from component
        setFilterOptionSelected(obj) {
            if (obj.mod == 'bmiData') {
                this.chartBMIMember.filterOptionSelected = obj.filterOptionSelected;
            } else if (obj.mod == 'waistData') {
                this.chartWaistMember.filterOptionSelected = obj.filterOptionSelected;
            } else if (obj.mod == 'workoutData') {
                this.chartWorkoutMember.filterOptionSelected = obj.filterOptionSelected;
            } else if (obj.mod == 'foodData') {
                this.chartFoodMember.filterOptionSelected = obj.filterOptionSelected;
            } else if (obj.mod == 'sleepData') {
                this.chartSleepMember.filterOptionSelected = obj.filterOptionSelected;
            } else if (obj.mod == 'bodyFatData') {
                this.chartBodyFatMember.filterOptionSelected = obj.filterOptionSelected;
            } else if (obj.mod == 'muscleData') {
                this.chartMuscleMember.filterOptionSelected = obj.filterOptionSelected;
            } else if (obj.mod == 'weightData') {
                this.chartWeightMember.filterOptionSelected = obj.filterOptionSelected;
            }
        },
        toUpdateChart(obj) {
            (async () => {
                this.filterStartDate = moment().subtract(3, 'Y').format('YYYY-MM-DD');
                this.filterEndDate = moment().format('YYYY-MM-DD');

                if (obj.filterOptionSelected == 'program') {
                    //get date from / to 
                    this.filterStartDate = this.startDate;
                    this.filterEndDate = this.endDate;
                } else if (obj.filterOptionSelected.indexOf(':') != -1) {
                    let filterArray = obj.filterOptionSelected.split(':');
                    this.filterStartDate = filterArray[0];
                    this.filterEndDate = filterArray[1];
                }
                this.setFilterOptionSelected(obj);
                this.modLoading[obj.mod] = true;
                this.fromLoadChart = obj.fromLoadChart;
                this.wellnessData[obj.mod] = await bqGetProgramMemberSummary(this.uid, this.filterStartDate, this.filterEndDate, obj.mod);
                await this.prepareChartData(obj.mod);
                this.modLoading[obj.mod] = false;
                this.fromLoadChart = false;
            })();
        },
        prepareChartData(mod) {
            if (mod == 'bmiData') {
                this.chartBMIMember.series[0].data = [] || 0;
                this.chartBMIMember.noData = true;
                if (this.wellnessData[mod].bmi.length) {
                    this.chartBMIMember.noData = false;
                    this.chartBMIMember.series[0].data = this.wellnessData[mod].bmi;
                    this.chartBMIMember.maxY = this.calculateMaxY(this.wellnessData[mod].bmiMaxY, this.chartBMIMember.maxY, 5);
                    this.chartBMIMember.chartSubTitle = this.calculatePercentChanges(this.wellnessData[mod].bmiStart, this.wellnessData[mod].bmiEnd) + '%';
                    this.chartBMIMember.title = this.chartBMIMember.chartTitle + '(' + this.chartBMIMember.chartSubTitle + ')';
                }
            } else if (mod == 'waistData') {
                this.chartWaistMember.series[0].data = [];
                this.chartWaistMember.noData = true;
                if (this.wellnessData[mod].waist.length) {
                    this.chartWaistMember.noData = false;
                    this.chartWaistMember.series[0].data = this.wellnessData[mod].waist;
                    this.chartWaistMember.maxY = this.calculateMaxY(this.wellnessData[mod].waistMaxY, this.chartWaistMember.maxY, 5);
                    this.chartWaistMember.chartSubTitle = this.calculatePercentChanges(this.wellnessData[mod].waistStart, this.wellnessData[mod].waistEnd) + '%';
                    this.chartWaistMember.title = this.chartWaistMember.chartTitle + '(' + this.chartWaistMember.chartSubTitle + ')';
                }
            } else if (mod == 'workoutData') {
                this.chartWorkoutMember.series[0].data = [];
                this.chartWorkoutMember.noData = true;

                if (this.wellnessData[mod].workout.length) {
                    this.chartWorkoutMember.noData = false;
                    this.chartWorkoutMember.series[0].data = this.wellnessData[mod].workout;
                    this.chartWorkoutMember.maxY = this.calculateMaxY(this.wellnessData[mod].workoutMaxY, this.chartWorkoutMember.maxY, 5);
                }
            } else if (mod == 'foodData') {
                this.chartFoodMember.series[0].data = [];
                this.chartFoodMember.noData = true;
                if (this.wellnessData[mod].food.length) {
                    this.chartFoodMember.noData = false;
                    this.chartFoodMember.series[0].data = this.wellnessData[mod].food;
                    this.chartFoodMember.maxY = this.calculateMaxY(this.wellnessData[mod].foodMaxY, this.chartFoodMember.maxY, 5);
                }
            } else if (mod == 'sleepData') {
                this.chartSleepMember.series[0].data = [];
                this.chartSleepMember.noData = true;
                if (this.wellnessData[mod].sleep.length) {
                    this.chartSleepMember.noData = false;
                    this.chartSleepMember.series[0].data = this.wellnessData[mod].sleep;
                    this.chartSleepMember.maxY = this.calculateMaxY(this.wellnessData[mod].foodMaxY, this.chartSleepMember.maxY, 5);
                }
            } else if (mod == 'bodyFatData') {
                this.chartBodyFatMember.series[0].data = [];
                this.chartBodyFatMember.noData = true;
                if (this.wellnessData[mod].bodyFat.length) {
                    this.chartBodyFatMember.noData = false;
                    this.chartBodyFatMember.series[0].data = this.wellnessData[mod].bodyFat;
                    this.chartBodyFatMember.maxY = this.calculateMaxY(this.wellnessData[mod].bodyFatMaxY, this.chartBodyFatMember.maxY, 5);
                    this.chartBodyFatMember.chartSubTitle = this.calculatePercentChanges(this.wellnessData[mod].bodyFatStart, this.wellnessData[mod].bodyFatEnd) + '%';
                    this.chartBodyFatMember.title = this.chartBodyFatMember.chartTitle + '(' + this.chartBodyFatMember.chartSubTitle + ')';
                }
            } else if (mod == 'muscleData') {
                this.chartMuscleMember.series[0].data = [];
                this.chartMuscleMember.noData = true;
                if (this.wellnessData[mod].muscle.length) {
                    this.chartMuscleMember.noData = false;
                    this.chartMuscleMember.series[0].data = this.wellnessData[mod].muscle;
                    this.chartMuscleMember.maxY = this.calculateMaxY(this.wellnessData[mod].muscleMaxY, this.chartMuscleMember.maxY, 5);
                    this.chartMuscleMember.chartSubTitle = this.calculatePercentChanges(this.wellnessData[mod].muscleStart, this.wellnessData[mod].muscleEnd) + '%';
                    this.chartMuscleMember.title = this.chartMuscleMember.chartTitle + '(' + this.chartMuscleMember.chartSubTitle + ')';
                }
            } else if (mod == 'weightData') {
                this.chartWeightMember.series[0].data = [];
                this.chartWeightMember.noData = true;
                if (this.wellnessData[mod].weight.length) {
                    this.chartWeightMember.noData = false;
                    this.chartWeightMember.series[0].data = this.wellnessData[mod].weight;
                    this.chartWeightMember.maxY = this.calculateMaxY(this.wellnessData[mod].weightMaxY, this.chartWeightMember.maxY, 5);
                    this.chartWeightMember.chartSubTitle = this.calculatePercentChanges(this.wellnessData[mod].weightStart, this.wellnessData[mod].weightEnd) + '%';
                    this.chartWeightMember.title = this.chartWeightMember.chartTitle + '(' + this.chartWeightMember.chartSubTitle + ')';
                }
            } else if (mod == 'pressureUpperData') {
                this.chartPressureUpperMember.series[0].data = [];
                this.chartPressureUpperMember.noData = true;
                if (this.wellnessData[mod].pressureUpper.length) {
                    this.chartPressureUpperMember.noData = false;
                    this.chartPressureUpperMember.series[0].data = this.wellnessData[mod].pressureUpper;
                    this.chartPressureUpperMember.maxY = this.calculateMaxY(this.wellnessData[mod].pressureUpperMaxY, this.chartPressureUpperMember.maxY, 5);
                }
            } else if (mod == 'pressureLowerData') {
                this.chartPressureLowerMember.series[0].data = [];
                this.chartPressureLowerMember.noData = true;
                if (this.wellnessData[mod].pressureLower.length) {
                    this.chartPressureLowerMember.noData = false;
                    this.chartPressureLowerMember.series[0].data = this.wellnessData[mod].pressureLower;
                    this.chartPressureLowerMember.maxY = this.calculateMaxY(this.wellnessData[mod].pressureLowerMaxY, this.chartPressureLowerMember.maxY, 5);
                }
            } else if (mod == 'glucoseData') {
                this.chartGlucoseMember.series[0].data = [];
                this.chartGlucoseMember.noData = true;
                if (this.wellnessData[mod].glucose.length) {
                    this.chartGlucoseMember.noData = false;
                    this.chartGlucoseMember.series[0].data = this.wellnessData[mod].glucose;
                    this.chartGlucoseMember.maxY = this.calculateMaxY(this.wellnessData[mod].glucoseMaxY, this.chartGlucoseMember.maxY, 5);
                }
            } else if (mod == 'hba1cData') {
                this.chartHba1cMember.series[0].data = [];
                this.chartHba1cMember.noData = true;
                if (this.wellnessData[mod].hba1c.length) {
                    this.chartHba1cMember.noData = false;
                    this.chartHba1cMember.series[0].data = this.wellnessData[mod].hba1c;
                    this.chartHba1cMember.maxY = this.calculateMaxY(this.wellnessData[mod].hba1cMaxY, this.chartHba1cMember.maxY, 5);
                }
            } else if (mod == 'cholesterolData') {
                this.chartCholesterolMember.series[0].data = [];
                this.chartCholesterolMember.noData = true;
                if (this.wellnessData[mod].cholesterol.length) {
                    this.chartCholesterolMember.noData = false;
                    this.chartCholesterolMember.series[0].data = this.wellnessData[mod].cholesterol;
                    this.chartCholesterolMember.maxY = this.calculateMaxY(this.wellnessData[mod].CholesterolMaxY, this.chartCholesterolMember.maxY, 5);
                }
            } else if (mod == 'hdlData') {
                this.chartHdlMember.series[0].data = [];
                this.chartHdlMember.noData = true;
                if (this.wellnessData[mod].hdl.length) {
                    this.chartHdlMember.noData = false;
                    this.chartHdlMember.series[0].data = this.wellnessData[mod].hdl;
                    this.chartHdlMember.maxY = this.calculateMaxY(this.wellnessData[mod].hdlMaxY, this.chartHdlMember.maxY, 5);
                }
            } else if (mod == 'ldlData') {
                this.chartLdlMember.series[0].data = [];
                this.chartLdlMember.noData = true;
                if (this.wellnessData[mod].ldl.length) {
                    this.chartLdlMember.noData = false;
                    this.chartLdlMember.series[0].data = this.wellnessData[mod].ldl;
                    this.chartLdlMember.maxY = this.calculateMaxY(this.wellnessData[mod].ldlMaxY, this.chartLdlMember.maxY, 5);
                }
            } else if (mod == 'triglyceridesData') {
                this.chartTriglyceridesMember.series[0].data = [];
                this.chartTriglyceridesMember.noData = true;
                if (this.wellnessData[mod].triglycerides.length) {
                    this.chartTriglyceridesMember.noData = false;
                    this.chartTriglyceridesMember.series[0].data = this.wellnessData[mod].triglycerides;
                    this.chartTriglyceridesMember.maxY = this.calculateMaxY(this.wellnessData[mod].triglyceridesMaxY, this.chartTriglyceridesMember.maxY, 5);
                }
            }
        }
    },
};
</script>
